// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import React from "react";
import { useNavigate } from 'react-router-dom';
import { PlasmicContractsListCard } from "./plasmic/collect_wise_draft/PlasmicContractsListCard";
import InProgressSign from "./InProgressSign"
import CompletedSign from "./CompletedSign"

function ContractsListCard_(props, ref) {
  const navigate = useNavigate()

  return <PlasmicContractsListCard root={{ ref, 
  onClick: () => navigate(`/contract/${props.id}`)
  }} {...props} contractStatusStack={{
    children: props.contractCompleted ? <CompletedSign/> : <InProgressSign/>
  }}
  />;
}

const ContractsListCard = React.forwardRef(ContractsListCard_);

export default ContractsListCard;
